/* eslint-disable */
import { GetterTree } from "vuex";
import { Tag } from "@/models/tag";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { TagState } from "@/types/tag";

const getters: GetterTree<TagState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Tag();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((tag) => Tag.toSelectItem(tag))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((tag) => {
          return tag.id == id;
        })
      : new Tag();
  },
};

export default getters;
